import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useGlobalStoreShallow } from 'src/store/globalStore';

import { StorageManager } from '@speeki/storage-manager';

import { Card } from '@components/molecules/Card/Card';
import { ColumnsLayout } from '@components/templates/ColumnsLayout/ColumnsLayout';
import { SuccessTemplate } from '@components/templates/SuccessTemplate/SuccessTemplate';

import { RequestPasswordResetDocument } from '@graphql/generated/graphql';

import { useMutation, useReactiveVar } from '@apollo/client';
import { forgotPasswordEmailVar } from '@boot/reactiveVariables';
import { ForgotPasswordForm } from '@domains/auth/organisms/ForgotPasswordForm/ForgotPasswordForm';

export const ForgotPasswordPage = () => {
    const { t } = useTranslation();
    const userEmail = useReactiveVar(forgotPasswordEmailVar);

    const { companyInfo } = useGlobalStoreShallow(['companyInfo']);

    const tenantUuid =
        companyInfo?.uuid || StorageManager.getValue('tenantUuid') || '';

    const [requestPasswordReset, { called, data: passwordResetData, error }] =
        useMutation(RequestPasswordResetDocument, {
            context: {
                notifyOnError: true,
            },
            onError: () => forgotPasswordEmailVar(''),
            variables: {
                passwordResetRequestInput: {
                    email: userEmail,
                    tenantUuid: tenantUuid,
                    type: 'EMPLOYEE',
                },
            },
        });

    const showForgotPasswordForm = (!called && !passwordResetData) || error;
    const showForgotPasswordConfirmation = passwordResetData?.success;

    useEffect(() => {
        !!userEmail && void requestPasswordReset();
    }, [userEmail]);

    return (
        <>
            {showForgotPasswordForm && (
                <ColumnsLayout>
                    <Card testId="hHAC-e2">
                        <Card.TitleTertiary>
                            {t('RESET_PASSWORD')}
                        </Card.TitleTertiary>
                        <Card.Description>
                            {t('FORGOT_PASSWORD_FORM_SUBTITLE')}
                        </Card.Description>
                        <ForgotPasswordForm />
                    </Card>
                </ColumnsLayout>
            )}
            {showForgotPasswordConfirmation && (
                <SuccessTemplate
                    texts={[
                        <>{t('FORGOT_PASSWORD_CONFIRMATION_SUBTITLE_1')}</>,
                        <>
                            {t('NOT_RECEIVE_MFA_RESET_EMAIL')}
                            <br />
                            {t('CHECK_JUNK_EMAIL_FOLDER')}
                        </>,
                    ]}
                    title={`${t(
                        'FORGOT_PASSWORD_CONFIRMATION_TITLE',
                    )} ${userEmail}`}
                ></SuccessTemplate>
            )}
        </>
    );
};
